import { useState, useEffect } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost, httpPatch } from "../../../api";

import MDPopup from "../../../components/MDPopup";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import MDSelect from "../../../components/MDSelect";


const Page = (props) => {
	const { user } = useAuthContext();

	const [model, setModel] = useState("");
	const [lot, setLot] = useState("");

	useEffect(() => {
		console.log(lot);
	}, [lot])

	const [validSubmit, setValidSubmit] = useState(false);

	useEffect(() => {
		console.log(model, lot);
		setValidSubmit(!!model && !!lot && model.length == 9 && lot.length == 3);
	}, [model, lot])

	useEffect(() => {
		setModel(props.model.model);
		setLot(props.model.lot);

		setValidSubmit(false)
	}, [props.open])

	const handleSubmit = async () => {
		let response;

		if (props.model.id != null){
			response = await httpPatch(process.env.REACT_APP_URL_BASE+`/tv/update/`, {
				id: props.model.id,
				model,
				lot
			})
		}else{
			response = await httpPost(process.env.REACT_APP_URL_BASE+`/tv/create`, {
				model,
				lot
			})
		}

		if (response.status != 201 && response.status != 200) {
            alert("Something went wrong");
            console.log(response);
            return
        }

        props.setRefreshed(true);
        props.close();
	}


	return <>
		<MDPopup display="flex" flexDirection="column" justifyContent="center" alignItems="center" open={props.open}>
	        <MDTypography variant="h3" color="info" textAlign="center" fontWeight="bold">Add new television</MDTypography>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">TV Name (9 char same as serial number) :</MDTypography>
	          <MDInput type="text" value={model} onChange={(e) => setModel(e.target.value.substring(0,9).toUpperCase())} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="50%">
	          <MDTypography variant="h6" color="text">Lot Number (3 char same as serial number) :</MDTypography>
	          <MDInput type="text" value={lot} onChange={(e) => setLot(e.target.value.toUpperCase().substring(0,3))} sx={{width: "100%"}} />
	        </MDBox>

	        <br />

	        <MDBox width="70%" textAlign="center">
	          <MDButton onClick={handleSubmit} disabled={!validSubmit} variant="text" color="success">Save</MDButton>
	          <MDButton variant="outlined" color="error" onClick={props.close}>Cancel</MDButton>
	        </MDBox>
	    </MDPopup>
	</>
}

export default Page